// Repositories/Notes.ts
import { createFetcher } from '../../Common';

import { queryBuilder } from '../../utils';

import { getBaseUrl, NOTES_ENDPOINT } from '../../constants';

export class Notes {
  private endpoint: string;

  private fetcher: any;

  constructor(fetcher: any) {
    this.endpoint = NOTES_ENDPOINT;
    this.fetcher = fetcher;
  }

  private get base_url(): string {
    return getBaseUrl();
  }

  // methods (unchanged)
  getAllNotes = async (reqParam?: Record<string, any>) => {
    const queryString = queryBuilder(reqParam ?? {});
    const url = `${this.base_url}${this.endpoint}${queryString}`;
    const response = await this.fetcher.getData(url);
    return { data: response?.data, meta: response?.meta };
  };

  getNoteById = async (reqId: number | string) => {
    const url = `${this.base_url}${this.endpoint}/${reqId}`;
    const response = await this.fetcher.getData(url);
    return response?.data;
  };

  getRepliesByParentId = async (parentId: number | string, reqParam?: Record<string, any>) => {
    const queryString = queryBuilder({ parentId, ...(reqParam || {}) });
    const url = `${this.base_url}${this.endpoint}${queryString}`;
    const response = await this.fetcher.getData(url);
    return { data: response?.data, meta: response?.meta };
  };

  postNote = async (reqBody: any) => {
    const url = `${this.base_url}${this.endpoint}`;
    const response = await this.fetcher.postData(url, reqBody);
    return response?.data;
  };

  putNoteById = async (reqParams: { reqId: number | string; reqBody?: any }) => {
    const url = `${this.base_url}${this.endpoint}/${reqParams.reqId}`;
    const response = await this.fetcher.putData(url, reqParams.reqBody);
    return response?.data;
  };

  deleteNoteById = async (reqParams: { reqId: number | string; reqBody?: any }) => {
    const url = `${this.base_url}${this.endpoint}/${reqParams.reqId}`;
    const response = await this.fetcher.deleteData(url, reqParams.reqBody);
    return response;
  };

  getNotesTaskById = async (reqId: number | string) => {
    const url = `${this.base_url}${this.endpoint.slice(0, -1)}/${reqId}/tasks`;
    const response = await this.fetcher.getData(url);
    return response?.data;
  };
}
// module-scoped singleton (lint-safe)
let notesInstance: Notes | null = null;

export const createNotes = () => {
  if (!notesInstance) notesInstance = new Notes(createFetcher());
  return notesInstance;
};
